export default function ExpoStripeProvider({children}: {children: React.ReactNode}) {
  return <>{children}</>;
}